/* eslint-disable unicorn/consistent-function-scoping */
/* eslint-disable arrow-body-style */
/* eslint-disable react/function-component-definition */
import { Paper } from "@material-ui/core";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { useState } from "react";

const ConfirmationDialog = ({
  open,
  title,
  message,
  onConfirm,
  onCancel,
  messageColor,
}: {
  open: boolean;
  title?: string;
  message: string;
  onConfirm?: () => void;
  onCancel?: () => void;
  messageColor?: string;
}) => {
  const [isOpen, setIsOpen] = useState(open);

  const handleClose = () => {
    setIsOpen(false);
  };
  return (
    <Dialog open={open} onClose={handleClose}>
      <Paper
        style={{
          width: "500px",
          padding: "25px",
        }}
      >
        <DialogTitle style={{ textAlign: "center" }}>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ color: messageColor, textAlign: "center" }}>
            {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-evenly" }}>
          {onCancel && (
            <Button
              sx={{ background: "#898989", width: "50%" }}
              variant="contained"
              onClick={onCancel}
              color="primary"
            >
              Cancel
            </Button>
          )}
          {onConfirm && (
            <Button
              sx={{ width: "50%" }}
              variant="contained"
              onClick={onConfirm}
              color="primary"
              autoFocus
            >
              OK
            </Button>
          )}
        </DialogActions>
      </Paper>
    </Dialog>
  );
};

export default ConfirmationDialog;
